import { cn } from '@sistemas/ui'
import { Link } from 'react-router-dom'

import { Avatar } from '@/components/ui/avatar'
import { matchesNavItem } from '@/lib/navigation'
import type { MOBILE_NAV } from '@/lib/mobile'

type MobileItem = (typeof MOBILE_NAV)[number]

/**
 * Barra inferior do celular (Onda 6.1): as quatro telas feitas para o toque e
 * o perfil. Fica no fluxo da coluna do shell (não `fixed`), então nunca cobre
 * o fim da página, e respeita a área do gesto de início do iPhone.
 */
export function MobileNav({
  items,
  pathname,
  onOpenProfile,
  profile,
}: {
  items: readonly MobileItem[]
  pathname: string
  onOpenProfile: () => void
  profile: { fullName: string; initials: string; avatarPath?: string | undefined }
}) {
  return (
    <nav
      aria-label="Navegação principal"
      className="shrink-0 border-t border-border bg-background pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <ul className="flex">
        {items.map((item) => {
          const active = matchesNavItem(pathname, item.to)
          return (
            <li key={item.to} className="flex-1">
              <Link
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'relative flex h-14 flex-col items-center justify-center gap-0.5 text-[11px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring',
                  active ? 'text-primary' : 'text-muted-foreground hover:text-foreground',
                )}
              >
                {active && <span aria-hidden className="absolute inset-x-5 top-0 h-0.5 rounded-b-full bg-primary" />}
                <item.icon className="h-5 w-5" aria-hidden />
                {item.label}
              </Link>
            </li>
          )
        })}
        <li className="flex-1">
          <button
            type="button"
            onClick={onOpenProfile}
            className="flex h-14 w-full flex-col items-center justify-center gap-0.5 text-[11px] font-medium text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
          >
            <Avatar person={profile} size="sm" showTitle={false} />
            Perfil
          </button>
        </li>
      </ul>
    </nav>
  )
}
